import PropTypes from 'prop-types';

const PROFILES_PROP_TYPES = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number,
    profile_type: PropTypes.string,
    avatar: PropTypes.string,
    position: PropTypes.string,
    name: PropTypes.string,
  }),
);

export default PROFILES_PROP_TYPES;
